import React from 'react';
import HorizontalScroller from './HorizontalScroller';

export default function PdfSlider({
  items = [],
  perViewDesktop = 3,
  perViewTablet  = 3,
  perViewMobile  = 2,
  perViewTiny    = 1,
  itemMin = 260,
  itemMax = 330,
  pad = 8,
  gap = 12,
}) {
  const list = Array.isArray(items) ? items : [];
  if (!list.length) return null;

  const isCompactDesktop = perViewDesktop <= 2;
  const maxWidthValue = isCompactDesktop
    ? perViewDesktop * itemMax + gap * (perViewDesktop - 1) + pad * 2
    : '100%';
  const shouldLimitDesktop = !isCompactDesktop;

  return (
    <HorizontalScroller
      perViewDesktop={perViewDesktop}
      perViewTablet={perViewTablet}
      perViewMobile={perViewMobile}
      perViewTiny={perViewTiny}
      itemMin={itemMin}
      itemMax={itemMax}
      maxWidth={maxWidthValue}
      centered
      pad={pad}
      gap={gap}
      limitDesktopWidth={shouldLimitDesktop}
    >
      {list.map((c, i) => (
        <div key={String(c.id ?? i)} style={{ width:'var(--col-width)' }}>
          <a
            href={c.href || '#'}
            target="_blank"
            rel="noopener"
            style={{
              display:'block',
              background:'var(--card)',
              border:'1px solid var(--bdr)',
              borderRadius:16,
              overflow:'hidden',
              boxShadow:'var(--shadow)',
              color:'inherit',
              textDecoration:'none'
            }}
          >
            {c.img && (
              <img
                src={c.img}
                alt={c.title || 'pdf'}
                loading="lazy"
                decoding="async"
                style={{height:170, width:'100%', objectFit:'cover', display:'block'}}
              />
            )}
            <h4 style={{
              margin:'10px 12px 6px', fontSize:16, lineHeight:1.25,
              display:'-webkit-box', WebkitBoxOrient:'vertical', WebkitLineClamp:2,
              overflow:'hidden', minHeight:'2.5em',
              color: '#000',
              background: 'var(--gold)',
              opacity: 0.92,
              padding: '8px 12px',
              borderRadius: '12px',
              backdropFilter: 'blur(8px)',
              boxShadow: '0 2px 10px rgba(0, 0, 0, 0.15)',
              border: '1px solid rgba(255, 255, 255, 0.3)',
              display: 'inline-block',
              width: 'calc(100% - 24px)',
              margin: '10px 12px 6px'
            }}>{c.title}</h4>
            {c.subtitle && <p style={{
              margin:'0 12px 12px', 
              opacity:.8,
              color: '#000',
              background: 'var(--gold)',
              opacity: 0.88,
              padding: '6px 10px',
              borderRadius: '10px',
              backdropFilter: 'blur(6px)',
              boxShadow: '0 1px 8px rgba(0, 0, 0, 0.1)',
              border: '1px solid rgba(255, 255, 255, 0.25)',
              display: 'inline-block',
              width: 'calc(100% - 24px)',
              margin: '6px 12px 12px'
            }}>{c.subtitle}</p>}
          </a>
        </div>
      ))}
    </HorizontalScroller>
  );
}


